import { render, staticRenderFns } from "./CmbMunicipios.vue?vue&type=template&id=060dbcc4&"
import script from "./CmbMunicipios.vue?vue&type=script&lang=js&"
export * from "./CmbMunicipios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports